exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.small.avatar.image {\n  margin: auto; }\n\n.main-lesson p {\n  margin: 1.4em 1em !important; }\n\n.main-lesson p.lesson-menu {\n  margin: 1.4em 1em !important; }\n\n.main-lesson .container {\n  margin-top: 50px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainSingingLesson/MainSingingLesson.scss
// module id = 1313
// module chunks = 0